import { combineReducers } from "redux";
import component from "./component";

export default combineReducers({ component });
